import { useCallback } from 'react';

import Text from '@zenbusiness/common-components/Text';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

import SharedAsset from '#client/components/SharedAsset';
import { useBreakpoints } from '#client/pages/EducationStudio/hooks/useBreakpoints';

import { TextArea } from '../../TextArea';

import { useLessonStorage } from '../../../hooks';
import { ExercisePage, MAX_CHARACTER_COUNT } from '../../Interactive/WorksheetActivity/exercisePage';
import { useStyles } from '../../Interactive/WorksheetActivity/useStyles';

const NEXT_BUTTON_TEXT = 'Next';
export const I_LOVE_TO = 'iLoveTo';

export const WhatYouLove = ({ onNext }) => {
  const { lesson } = useParams();
  const { getStorageValue, setStorageValue, saveChanges } = useLessonStorage(lesson);
  const {
    sizes: { isMobile }
  } = useBreakpoints();
  const classes = useStyles();

  const onNextHandler = useCallback(() => {
    saveChanges();
    onNext();
  }, [saveChanges, onNext]);

  const presentation = (
    <Box className={classNames(classes.imageContainer, classes.bottomSpacing)}>
      <SharedAsset
        className={classes.responsiveImage}
        src="/journey%20to%20success/01%20MVE%20Series/01%20PEAKS/mve_peaks_exercise2.svg"
        alt="ikigai-exercise"
        width={500}
      />
    </Box>
  );

  return (
    <ExercisePage
      caption="Exercise"
      title="What you love &#10084;&#65039;"
      presentation={presentation}
      buttonText={NEXT_BUTTON_TEXT}
      isButtonDisabled={!getStorageValue(I_LOVE_TO)}
      onNext={onNextHandler}
    >
      <Text size={isMobile ? 'lg' : 'sm'} bold>Ask yourself:</Text>
      <ul className={classNames(classes.list, classes.bottomSpacing)}>
        <li>
          <Text size={isMobile ? 'lg' : 'sm'}>What makes me feel &lsquo;in flow&rsquo;?</Text>
        </li>
        <li>
          <Text size={isMobile ? 'lg' : 'sm'}>What am I passionate and excited about?</Text>
        </li>
        <li>
          <Text size={isMobile ? 'lg' : 'sm'}>What gets me out of bed in the morning?</Text>
        </li>
      </ul>
      <TextArea
        placeholder="I love to..."
        text={getStorageValue(I_LOVE_TO)}
        onChangeHandler={(e) => setStorageValue(I_LOVE_TO, e.target.value)}
        className={classes.bottomSpacing}
        maxLength={MAX_CHARACTER_COUNT}
      />
      {!isMobile && (
      <Button
        className={`${classes.nextButton} ${classes.buttonRight}`}
        variant="contained"
        color="primary"
        size="large"
        disabled={!getStorageValue(I_LOVE_TO)}
        onClick={() => onNextHandler()}
      >
        {NEXT_BUTTON_TEXT}
      </Button>
      )}
    </ExercisePage>
  );
};

WhatYouLove.propTypes = {
  onNext: PropTypes.func
};

WhatYouLove.defaultProps = {
  onNext: () => {}
};

export default WhatYouLove;
